import React from "react";
import Modal from "@ROM-components/common/Modal";

const SubmitModal = ({ show = false, onCancel, handleConfirm, header }) => (
  <Modal isShowing={show} onConfirm={handleConfirm} onCancel={onCancel} header={header} showCloseIcon={false} />
);
export default SubmitModal;
